import { SpaceAvailability } from 'state/ducks/space/models.new'

export const getSpaceAvailabilities = (availability: SpaceAvailability) => {
  let iconImage: { src: string; alt: string } = {
    src: '/empty_status_circle_03.svg',
    alt: '◯',
  }

  if (availability.is_holiday) {
    iconImage.src = '/empty_status_cross.svg'
    iconImage.alt = 'x'
  } else {
    if (availability.ratio > 0 && availability.ratio < 100) {
      iconImage.src = '/empty_status_triangle.svg'
      iconImage.alt = '△'
    }

    if (availability.ratio === 0) {
      iconImage.src = '/empty_status_circle_03.svg'
      iconImage.alt = '◯'
    }

    if (availability.ratio === 100) {
      iconImage.src = '/empty_status_cross.svg'
      iconImage.alt = 'x'
    }
  }

  const _date = new Date(availability.date)
  const month: number = _date.getMonth() + 1
  const day: number = _date.getDate()
  const date: string = `${month}/${day}`

  return {
    date,
    iconImage,
  }
}

export const scrollToTop = () => {
  const pos = Math.max(
    window.pageYOffset,
    document.documentElement.scrollTop,
    document.body.scrollTop
  )

  console.log('pos', pos)

  if (pos > 0) {
    document.querySelector('body').scrollTo(0, 0)
  }
}
